import React from "react";
import {Inline, Text, usePatronTheme} from "@unibuddy/patron";
import {Align} from "./ChatMessage";

type ChatHeaderProps = {
    align: Align;
    formattedTime?: string | null;
};

export function ChatMessageHeader({align, formattedTime}: Readonly<ChatHeaderProps>) {
    const theme = usePatronTheme();
    const middleDot = "\u00b7";
    return (
        <Inline verticalAlign="center" space="xxsmall">
            <Text size="small" weight="bold" color={theme.colors.primaryColor} lineHeight="inherit">
                {align === "left" ? "Assistant" : "You"}
            </Text>
            {formattedTime && (
                <Text size="xxsmall" weight="bold" lineHeight="inherit">
                    {middleDot}
                </Text>
            )}
            {formattedTime && (
                <Text size="xxsmall" lineHeight="inherit">
                    {formattedTime}
                </Text>
            )}
        </Inline>
    );
}
